import styled from 'styled-components';

export const StyledDiv = styled.div`
  .minus-button {
    vertical-align: top;
  }
`;

export const StyledFlexDiv = styled.div`
  display: flex;
`;
